// extracted by mini-css-extract-plugin
export default {"canvas":"styles_canvas__r8hpZ","overlay":"styles_overlay__hgHTV","removeOverlay":"styles_removeOverlay__TVPnb"};